var a = /* @__PURE__ */function (N) {
    return N.STANDARD = "standard", N.INLINE_ICON = "inline-icon", N.STACKED_ICON = "stacked-icon", N;
  }(a || {}),
  n = /* @__PURE__ */function (N) {
    return N.PRIMARY = "primary", N.SECONDARY = "secondary", N.TERTIARY = "tertiary", N.PAGINATION = "pagination", N.ZONED = "zoned", N;
  }(n || {});
export { n as A, a as N };